<template>
  <div>
    <ul class="p-project-edit-list">
      <li class="p-project-edit-list__item">
        <div class="p-dialog-option-v1__deprecation-notice">
          <div class="p-dialog-option-v1__deprecation-title">【非推奨】V1(旧デザイン)</div>
          <div class="p-dialog-option-v1__deprecation-body">
            V1(旧デザイン)は将来的に廃止予定です。<br />
            V2(新デザイン)では、画像・タイトル・説明文などをより自由にカスタマイズすることで、サイトイメージに合わせた表示が可能です。<br />
            現在は V1 / V2 の両方が動作しますが、V2 への載せ替えをご検討ください(上部の「V2」タブから設定できます)。
          </div>
        </div>
      </li>
      <li class="p-project-edit-list__item">
        <div class="c-input">
          <div class="c-input__title u-w190">アイコン画像URL

            <div class="c-upload">
              <label class="c-upload__label" style="padding: 0;">
                <div class="c-upload__data" style="padding: 0;">
                  <input
                    ref="iconInput"
                    type="file"
                    name="message_icon"
                    value=""
                    placeholder="ファイルの選択"
                    @change="selectIconFile"
                  />
                  <span class="c-upload__btn">ファイルの選択</span>
                </div>
              </label>
              <input type="hidden" name="message_icon_attachement_data" value="" />
              <div class="c-error" :class="{ 'is-active': errors.icon !== '' }">
                <div class="c-error__text">{{ errors.icon }}</div>
              </div>
            </div>
          </div>

          <input
            v-model="icon"
            type="text"
            class="c-input__item u-w680"
            @keyup="generateScript"
            @input="checkImageURL"
            @blur="updateScript()"
          />
        </div>
      </li>
      <li class="p-project-edit-list__item">
        <div class="c-input">
          <div class="c-input__title u-w190">
            ダイアログテキスト
            <div class="c-error" :class="{ 'is-active': errors.dialogText !== '' }">
              <div class="c-error__text">{{ errors.dialogText }}</div>
            </div>
          </div>
          <input
            v-model="message"
            type="text"
            class="c-input__item u-w680"
            maxlength="40"
            @keyup="generateScript"
            @input="checkDialogTextLength"
            @blur="updateScript()"
          />
        </div>
      </li>
      <li class="p-project-edit-list__item">
        <div class="c-input">
          <div class="c-input__title u-w190">
            ボタンテキスト
            <div class="c-error" :class="{ 'is-active': errors.buttonText !== '' }">
              <div class="c-error__text">{{ errors.buttonText }}</div>
            </div>
          </div>
          <input
            v-model="button"
            type="text"
            class="c-input__item u-w680"
            maxlength="20"
            @keyup="generateScript"
            @input="checkButtonTextLength"
            @blur="updateScript()"
          />
        </div>
      </li>
      <li class="p-project-edit-list__item">
        <div class="c-input">
          <div class="c-input__title u-w190">次回表示までの間隔</div>
          <!-- <input type="number" class="c-input__item u-w680" v-model="interval" @keyup="generateScript" /> -->
          <div class="c-radio u-w680">
            <ul class="c-radio-list">
              <li class="c-radio-list__item" style="margin-bottom: 0;">
                <label class="c-radio__label">
                  <input
                    v-model="intervalRadio"
                    type="radio"
                    name="interval"
                    value="1"
                    @change="updateScript()"
                  />
                  <div class="c-radio__item">
                    <div class="c-radio__box"></div>
                    <div class="c-radio__box-label">1日後</div>
                  </div>
                </label>
              </li>
              <li class="c-radio-list__item" style="margin-bottom: 0;">
                <label class="c-radio__label">
                  <input
                    v-model="intervalRadio"
                    type="radio"
                    name="interval"
                    value="2"
                    @change="updateScript()"
                  />
                  <div class="c-radio__item">
                    <div class="c-radio__box"></div>
                    <div class="c-radio__box-label">2日後</div>
                  </div>
                </label>
              </li>
              <li class="c-radio-list__item" style="margin-top: 0; margin-bottom: 0;">
                <label class="c-radio__label">
                  <input
                    v-model="intervalRadio"
                    type="radio"
                    name="interval"
                    value="3"
                    @change="updateScript()"
                  />
                  <div class="c-radio__item">
                    <div class="c-radio__box"></div>
                    <div class="c-radio__box-label">3日後</div>
                  </div>
                </label>
              </li>
            </ul>
          </div>
        </div>
      </li>
      <li class="p-project-edit-list__item">
        <div class="c-input">
          <div class="c-input__title u-w190">表示のカスタマイズ</div>
          <div class="c-radio u-w680">
            <ul v-show="canSelectCustomize" class="c-radio-list">
              <li class="c-radio-list__item" style="margin-bottom: 0;">
                <label class="c-radio__label">
                  <input
                    v-model="hasCustomStyle"
                    type="radio"
                    name="hasCustomStyle"
                    :value="false"
                    @change="updateScript()"
                  />
                  <div class="c-radio__item">
                    <div class="c-radio__box"></div>
                    <div class="c-radio__box-label">なし</div>
                  </div>
                </label>
              </li>
              <li class="c-radio-list__item" style="margin-top: 0; margin-bottom: 0">
                <label class="c-radio__label">
                  <input
                    v-model="hasCustomStyle"
                    type="radio"
                    name="hasCustomStyle"
                    :value="true"
                    @change="updateScript()"
                  />
                  <div class="c-radio__item">
                    <div class="c-radio__box"></div>
                    <div class="c-radio__box-label">あり</div>
                  </div>
                </label>
              </li>
            </ul>
          </div>
        </div>
      </li>
      <li v-show="hasCustomStyle" class="p-project-edit-list__item child-item">
        <div class="c-input">
          <div class="c-input__title u-w190">表示位置(上下)</div>
          <div class="c-radio u-w680">
            <ul class="c-radio-list">
              <li class="c-radio-list__item" style="margin-bottom: 0;">
                <label class="c-radio__label">
                  <input
                    v-model="customStyle.vertical"
                    type="radio"
                    name="vertical"
                    value="top"
                    @change="updateScript()"
                  />
                  <div class="c-radio__item">
                    <div class="c-radio__box"></div>
                    <div class="c-radio__box-label">上</div>
                  </div>
                </label>
              </li>
              <li class="c-radio-list__item" style="margin-top: 0; margin-bottom: 0">
                <label class="c-radio__label">
                  <input
                    v-model="customStyle.vertical"
                    type="radio"
                    name="vertical"
                    value="bottom"
                    @change="updateScript()"
                  />
                  <div class="c-radio__item">
                    <div class="c-radio__box"></div>
                    <div class="c-radio__box-label">下</div>
                  </div>
                </label>
              </li>
            </ul>
          </div>
        </div>
      </li>
      <li v-show="hasCustomStyle" class="p-project-edit-list__item child-item">
        <div class="c-input">
          <div class="c-input__title u-w190">表示位置(左右)</div>
          <div class="c-radio u-w680">
            <ul class="c-radio-list">
              <li class="c-radio-list__item" style="margin-bottom: 0;">
                <label class="c-radio__label">
                  <input
                    v-model="customStyle.horizontal"
                    type="radio"
                    name="horizontal"
                    value="left"
                    @change="updateScript()"
                  />
                  <div class="c-radio__item">
                    <div class="c-radio__box"></div>
                    <div class="c-radio__box-label">左</div>
                  </div>
                </label>
              </li>
              <li class="c-radio-list__item" style="margin-top: 0; margin-bottom: 0">
                <label class="c-radio__label">
                  <input
                    v-model="customStyle.horizontal"
                    type="radio"
                    name="horizontal"
                    value="center"
                    @change="updateScript()"
                  />
                  <div class="c-radio__item">
                    <div class="c-radio__box"></div>
                    <div class="c-radio__box-label">中央</div>
                  </div>
                </label>
              </li>
              <li class="c-radio-list__item" style="margin-top: 0; margin-bottom: 0">
                <label class="c-radio__label">
                  <input
                    v-model="customStyle.horizontal"
                    type="radio"
                    name="horizontal"
                    value="right"
                    @change="updateScript()"
                  />
                  <div class="c-radio__item">
                    <div class="c-radio__box"></div>
                    <div class="c-radio__box-label">右</div>
                  </div>
                </label>
              </li>
            </ul>
          </div>
        </div>
      </li>
      <li v-show="hasCustomStyle" class="p-project-edit-list__item child-item">
        <div class="c-input">
          <div class="c-input__title u-w190">サイズ</div>
          <div class="c-radio u-w680">
            <ul class="c-radio-list">
              <li class="c-radio-list__item" style="margin-bottom: 0;">
                <label class="c-radio__label">
                  <input
                    v-model="customStyle.size"
                    type="radio"
                    name="size"
                    value="small"
                    @change="updateScript()"
                  />
                  <div class="c-radio__item">
                    <div class="c-radio__box"></div>
                    <div class="c-radio__box-label">小さめ</div>
                  </div>
                </label>
              </li>
              <li class="c-radio-list__item" style="margin-top: 0; margin-bottom: 0">
                <label class="c-radio__label">
                  <input
                    v-model="customStyle.size"
                    type="radio"
                    name="size"
                    value="large"
                    @change="updateScript()"
                  />
                  <div class="c-radio__item">
                    <div class="c-radio__box"></div>
                    <div class="c-radio__box-label">大きめ</div>
                  </div>
                </label>
              </li>
            </ul>
          </div>
        </div>
      </li>
      <li v-show="hasCustomStyle" class="p-project-edit-list__item child-item">
        <div class="c-input">
          <div class="c-input__title u-w190">デザイン</div>
          <div class="c-radio u-w680">
            <ul class="c-radio-list">
              <li class="c-radio-list__item" style="margin-bottom: 0;">
                <label class="c-radio__label">
                  <input
                    v-model="customStyle.design"
                    type="radio"
                    name="design"
                    :value="1"
                    @change="updateScript()"
                  />
                  <div class="c-radio__item">
                    <div class="c-radio__box"></div>
                    <div class="c-radio__box-label">タイプ1</div>
                  </div>
                </label>
              </li>
              <li class="c-radio-list__item" style="margin-top: 0; margin-bottom: 0">
                <label class="c-radio__label">
                  <input
                    v-model="customStyle.design"
                    type="radio"
                    name="design"
                    :value="2"
                    @change="updateScript()"
                  />
                  <div class="c-radio__item">
                    <div class="c-radio__box"></div>
                    <div class="c-radio__box-label">タイプ2</div>
                  </div>
                </label>
              </li>
              <li class="c-radio-list__item" style="margin-top: 0; margin-bottom: 0">
                <label class="c-radio__label">
                  <input
                    v-model="customStyle.design"
                    type="radio"
                    name="design"
                    :value="3"
                    @change="updateScript()"
                  />
                  <div class="c-radio__item">
                    <div class="c-radio__box"></div>
                    <div class="c-radio__box-label">タイプ3</div>
                  </div>
                </label>
              </li>
            </ul>
          </div>
        </div>
      </li>
      <li v-show="hasCustomStyle" class="p-project-edit-list__item child-item">
        <div class="c-input">
          <div class="c-input__title u-w190">ボタンタイプ</div>
          <div class="c-radio u-w680">
            <ul class="c-radio-list">
              <li class="c-radio-list__item" style="margin-bottom: 0;">
                <label class="c-radio__label">
                  <input
                    v-model="customStyle.buttonType"
                    type="radio"
                    name="buttonType"
                    :value="1"
                    @change="updateScript()"
                  />
                  <div class="c-radio__item">
                    <div class="c-radio__box"></div>
                    <div class="c-radio__box-label">タイプ1</div>
                  </div>
                </label>
              </li>
              <li class="c-radio-list__item" style="margin-top: 0; margin-bottom: 0">
                <label class="c-radio__label">
                  <input
                    v-model="customStyle.buttonType"
                    type="radio"
                    name="buttonType"
                    :value="2"
                    @change="updateScript()"
                  />
                  <div class="c-radio__item">
                    <div class="c-radio__box"></div>
                    <div class="c-radio__box-label">タイプ2</div>
                  </div>
                </label>
              </li>
              <li class="c-radio-list__item" style="margin-top: 0; margin-bottom: 0">
                <label class="c-radio__label">
                  <input
                    v-model="customStyle.buttonType"
                    type="radio"
                    name="buttonType"
                    :value="3"
                    @change="updateScript()"
                  />
                  <div class="c-radio__item">
                    <div class="c-radio__box"></div>
                    <div class="c-radio__box-label">タイプ3</div>
                  </div>
                </label>
              </li>
            </ul>
          </div>
        </div>
      </li>
      <li v-show="hasCustomStyle" class="p-project-edit-list__item child-item">
        <div class="c-input">
          <div class="c-input__title u-w190">ポップアップの閉じ方</div>
          <div class="c-radio u-w680">
            <ul class="c-radio-list">
              <li class="c-radio-list__item" style="margin-bottom: 0;">
                <label class="c-radio__label">
                  <input
                    v-model="customStyle.close.type"
                    type="radio"
                    name="close"
                    value="cross"
                    @change="updateScript()"
                  />
                  <div class="c-radio__item">
                    <div class="c-radio__box"></div>
                    <div class="c-radio__box-label"><span style="font-size: large;font-weight: bold">×</span>マーク</div>
                  </div>
                </label>
              </li>
              <li class="c-radio-list__item" style="margin-top: 0; margin-bottom: 0">
                <label class="c-radio__label">
                  <input
                    v-model="customStyle.close.type"
                    type="radio"
                    name="close"
                    value="button"
                    @change="updateScript()"
                  />
                  <div class="c-radio__item">
                    <div class="c-radio__box"></div>
                    <div class="c-radio__box-label">ボタン</div>
                  </div>
                </label>
              </li>
            </ul>
          </div>
        </div>
      </li>
      <li v-show="hasCustomStyle && customStyle.close.type === 'button'" class="p-project-edit-list__item child-item child-item" style="margin-left: 100px;">
        <div class="c-input">
          <div class="c-input__title u-w190">
            閉じるボタンのテキスト
          </div>
          <input
            v-model="customStyle.close.text"
            type="text"
            class="c-input__item u-w580"
            maxlength="20"
            @keyup="generateScript"
            @input="checkButtonTextLength"
            @blur="updateScript()"
          />
        </div>
      </li>
      <li class="p-project-edit-list__item">
        <div class="c-textarea" style="align-items: normal;">
          <div class="c-textarea__title">オプションタグ</div>
          <textarea
            ref="scriptTextarea"
            v-tooltip.top-start="{
              content: isChanged ? '設定を更新しました。新しいオプションタグをページに設置して、変更を反映してください。' : '',
              shown: isChanged,
            }"
            style="margin-left: auto;"
            class="c-textarea__item u-w630 u-h300"
            :name="data.copyId"
            :style="{ backgroundColor: isChanged ? '#d7eff5' : 'inherit' }"
            readonly
          >
                    </textarea>

          <button
            class="c-btn c-btn--circle"
            type="button"
            name="clip"
            value="add-user"
            @click="onClipClick($event)"
          >
            <div
              v-tooltip="{
                content: isCopied
                  ? 'コピーしました'
                  : 'クリップボードにコピー',
                hideTriggers: (triggers) => triggers.filter((trigger) => trigger !== 'click'),
              }"
              @click="toggleCopyText"
            >
              <div class="c-icon-circle c-icon-circle--gray-2 u-wh40">
                <div class="c-icon-circle__item c-icon-circle__item--white c-icon__item--alpha70 u-wh20">
                  <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <use xlink:href="/assets/img/sprite.svg#clipboard" />
                  </svg>
                </div>
              </div>
            </div>
          </button>
        </div>
      </li>
    </ul>
    <!-- オプトインダイアログのプレビュー -->
    <CustomOptinDialogModule v-if="showPreview && hasCustomStyle" :dialog-values="dialogValues" @close="$emit('close-preview')" />
    <DefaultOptinDialogModule v-else-if="showPreview && !hasCustomStyle" :dialog-values="dialogValues" @close="$emit('close-preview')" />
  </div>
</template>

<script>
import axios from "axios";
import CustomOptinDialogModule from '../molecules/CustomOptinDialogModule.vue'
import DefaultOptinDialogModule from '../molecules/DefaultOptinDialogModule.vue'
import { DEFAULT_OPTIN_DIALOG_ICON_URL } from '../../funcs/constants';
export default {
  components: { CustomOptinDialogModule, DefaultOptinDialogModule },
  props: {
    copyId: String,
    serviceCreateDate: {
      type: String,
      default: '',
    },
    showPreview: {
      type: Boolean,
      default: false,
    },
    isActive: {
      type: Boolean,
      default: true,
    },
    projectIconUrl: {
      type: String,
      default: '',
    },
    initialData: {
      type: Object,
      default: null,
    },
  },
  emits: ["close-preview"],
  data() {
    return {
      data: {
        copyId: this.copyId,
      },

      icon: "",
      message: "",
      button: "",
      interval: "",
      intervalRadio: 1,

      hasCustomStyle: false,
      customStyle: {
        vertical: "top",
        horizontal: "left",
        size: "small",
        design: 1,
        buttonType: 1,
        close: {
          type: "cross",
          text: "設定しない",
        },
      },

      defaultMessage: "このサイトからの通知を設定しますか?",
      defaultButton: "設定する",
      defaultInterval: 24 * 60 * 60,

      iconUrl: '',
      errors: {
        icon: '',
        dialogText: '',
        buttonText: '',
      },
      acceptableMimeTypes: [
        'image/png',
        'image/jpeg',
        'image/gif',
      ],

      isCopied: false,
      isChanged: false,
    }
  },
  computed: {
    dialogValues() {
      return {
        icon: this.icon,
        message: this.message,
        button: this.button,
        customStyle: this.hasCustomStyle
          ? {
            vertical: this.customStyle.vertical,
            horizontal: this.customStyle.horizontal,
            size: this.customStyle.size,
            design: this.customStyle.design,
            buttonType: this.customStyle.buttonType,
            close: {
              type: this.customStyle.close.type,
              text: this.customStyle.close.text ?? '',
            },
          }
          : undefined,
      };
    },
    canSelectCustomize: function () {
      if (location.pathname.endsWith("/onboarding/tag")) {
        return false;
      }

      if (!this.serviceCreateDate) {
        return false;
      }

      // プレオプトインカスタマイズの改修リリース日: 2024-11-12
      // この日以降に作られたプロジェクトは表示カスタマイズの選択肢を表示させない
      if (new Date(this.serviceCreateDate) >= new Date("2024-11-12")) {
        return false;
      }

      return true;
    },
  },
  watch: {
    isActive(newVal) {
      if (!newVal) {
        this.isChanged = false;
      }
    },
  },
  mounted() {
    this.setDefaultValues();
  },
  methods: {
    generateScript() {
      let scriptContent = "<script>\n";
      scriptContent += "var CoinsOptinDialogOption = {\n";
      if (this.icon !== "") {
        let icon = this.icon;
        if (this.iconUrl) {
          icon = this.iconUrl;
        }
        scriptContent += `    icon: '${icon}',\n`;
      }
      if (this.message !== "") {
        scriptContent += `    message: '${this.message}',\n`;
      }
      if (this.button !== "") {
        scriptContent += `    button: '${this.button}',\n`;
      }
      if (this.interval !== "") {
        const interval = this.interval * this.intervalRadio;
        scriptContent += this.hasCustomStyle
          ? `    interval: ${interval},\n`
          : `    interval: ${interval}\n`;
      }
      if (this.hasCustomStyle) {
        scriptContent += "    customStyle: {\n";
        scriptContent += `        vertical: '${this.customStyle.vertical}',\n`;
        scriptContent += `        horizontal: '${this.customStyle.horizontal}',\n`;
        scriptContent += `        size: '${this.customStyle.size}',\n`;
        scriptContent += `        design: ${this.customStyle.design},\n`;
        scriptContent += `        buttonType: ${this.customStyle.buttonType},\n`;
        scriptContent += "        close: {\n";
        if (this.customStyle.close.type === 'button') {
          scriptContent += `            type: '${this.customStyle.close.type}',\n`;
          scriptContent += `            text: '${this.customStyle.close.text ?? ''}'\n`;
        } else {
          scriptContent += `            type: '${this.customStyle.close.type}'\n`;
        }
        scriptContent += "        }\n";
        scriptContent += "    }\n";
      }
      scriptContent += "}\n";
      scriptContent += "</" + "script>";
      this.$refs.scriptTextarea.value = scriptContent;
    },
    onClipClick: function(event) {
      event.preventDefault();
      let text = $(`textarea[name="${this.data.copyId}"]`).prop('value');
      this.$copyText(text).then(function (_e) {
      }, function (_e) {
      })
    },
    setDefaultValues: function () {
      this.applyInitialData();
      const defaultIconUrl = this.projectIconUrl || DEFAULT_OPTIN_DIALOG_ICON_URL;
      this.icon = this.icon ? this.icon : defaultIconUrl;
      this.message = this.message ? this.message : this.defaultMessage;
      this.button = this.button ? this.button : this.defaultButton;
      if (this.interval != undefined) {
        this.intervalRadio = this.interval / this.defaultInterval;
      }
      this.interval = this.defaultInterval;
      this.generateScript();
    },
    applyInitialData: function () {
      const data = this.initialData;
      if (!data) {
        if (!this.canSelectCustomize) {
          this.hasCustomStyle = true;
        }
        return;
      }
      this.icon = data.icon;
      this.message = data.message;
      this.button = data.button;
      this.interval = data.interval;
      this.hasCustomStyle = data.hasCustomStyle ?? false;
      if (!this.canSelectCustomize) {
        this.hasCustomStyle = true;
      }
      if (data.customStyle) {
        this.customStyle = data.customStyle;
      }
    },
    isAcceptableMimeType: function (mimeType) {
      var isAcceptable = false;
      this.acceptableMimeTypes.forEach(function (acceptableMimeType) {
        if (acceptableMimeType == mimeType) {
          isAcceptable = true;
        }
      });
      return isAcceptable;
    },
    selectIconFile: function () {
      const iconFile = this.$refs.iconInput.files[0];
      this.errors.icon = '';

      if (!this.isAcceptableMimeType(iconFile.type)) {
        this.setIconErrorMessage('アイコン画像はPNG/JPEG/GIF形式のファイルを指定してください。');
        return;
      }

      const fileReader = new FileReader();

      fileReader.onload = () => {
        const offset = fileReader.result.indexOf(",") + 1;
        const base64 = fileReader.result.slice(offset);
        const data = `data:${iconFile.type};base64,${base64}`;

        const params = {
          data: data,
          max_size: 128,
          max_bytes: 66560
        }
        this.optimizeImage(params, (optimizedImage) => {
          if (optimizedImage) {
            if (optimizedImage.filesize > 66560) { // 64KB
              this.setIconErrorMessage('アイコン画像は64KB以下のファイルを指定してください。');
              return;
            }
            this.icon = optimizedImage.data;
          } else {
            if (iconFile.size > 66560) { // 64KB
              this.setIconErrorMessage('アイコン画像は64KB以下のファイルを指定してください。');
              return;
            }
            this.icon = data;
          }

          axios.post('/api/script-tag-setting/save-image', { icon: this.icon })
            .then(response => {
              this.icon = response.data;
              this.updateScript();
            })
            .catch(_error => {
            });
        });
      };
      fileReader.readAsDataURL(iconFile);
    },
    optimizeImage: function (params, callback) {
      const endpoint = 'https://bpjflajowoc3zds6vfdqnhcfs40irvbj.lambda-url.ap-northeast-1.on.aws';
      axios.post(endpoint, params)
        .then(res => {
          callback(res.data);
        })
        .catch(_e => {
          callback(null);
        });
    },
    setIconErrorMessage: function (message) {
      this.errors.icon = message;
      this.$forceUpdate();
    },
    checkDialogTextLength: function(event) {
      this.checkTextLength(event, this.errors, 'dialogText');
    },
    checkButtonTextLength: function(event) {
      this.checkTextLength(event, this.errors, 'buttonText');
    },
    checkTextLength: function(event, target, errorMessage) {
      const maxLength = event.target.getAttribute("maxlength");
      if (event.target.value.length >= maxLength) {
        target[errorMessage] = `テキストは${maxLength}文字までです`;
        event.target.blur();
        this.generateScript();
      } else {
        target[errorMessage] = '';
      }
    },
    checkImageURL: function (event) {
      this.setIconErrorMessage('');
      const url = event.target.value;
      axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8';
      axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
      axios.get(url)
        .then(response => {
          if (response.status === 200) {
            const contentType = response.headers['content-type'];
            if (!this.isAcceptableMimeType(contentType)) {
              this.setIconErrorMessage('アイコン画像はPNG/JPEG/GIF形式のファイルを指定してください。');
            }
          } else {
            this.setIconErrorMessage('画像が取得出来ませんでした。URLをご確認ください。');
          }
        })
        .catch(_error => {
          this.setIconErrorMessage('画像が取得出来ませんでした。URLをご確認ください。');
        });
    },
    saveOptionTagSettings: function () {
      const data = {
        icon: this.icon,
        message: this.message,
        button: this.button,
        interval: this.interval * this.intervalRadio,
        hasCustomStyle: this.hasCustomStyle,
      }
      if (this.hasCustomStyle) {
        data['customStyle'] = this.customStyle;
      }
      axios.post('/api/script-tag-setting/save-option', data)
        .then(_res => {})
        .catch(_e => {});
    },
    toggleCopyText: function () {
      this.isCopied = true;
      setTimeout(() => {
        this.isCopied = false;
      }, 2000);
    },
    updateScript: function () {
      if (!location.pathname.endsWith('/onboarding/tag')) {
        this.isChanged = true;
      }
      this.generateScript();
      this.saveOptionTagSettings();
    }
  },
}
</script>

<style scoped>
.p-dialog-option-v1__deprecation-notice {
    box-sizing: border-box;
    width: 100%;
    padding: 12px 16px;
    margin: 16px 0;
    font-size: 14px;
    line-height: 1.5;
    color: #b7791f;
    background: #fef6d7;
    border: 1px solid #f2d78e;
    border-radius: 4px;
}
.p-dialog-option-v1__deprecation-title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 8px;
}
</style>
